var app;
(function (app) {
    var pesquisaAvancada;
    (function (pesquisaAvancada) {
        "use strict";
        var ComparisonOperator = /** @class */ (function () {
            function ComparisonOperator() {
            }
            Object.defineProperty(ComparisonOperator, "EQUALS", {
                get: function () { return "EQUALS"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "CONTAINS", {
                get: function () { return "CONTAINS"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "BETWEEN", {
                get: function () { return "BETWEEN"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "GREATER_THAN", {
                get: function () { return "GREATER_THAN"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "LESS_THAN", {
                get: function () { return "LESS_THAN"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ComparisonOperator, "EXISTS", {
                get: function () { return "EXISTS"; },
                enumerable: true,
                configurable: true
            });
            return ComparisonOperator;
        }());
        pesquisaAvancada.ComparisonOperator = ComparisonOperator;
        var LogicalOperator = /** @class */ (function () {
            function LogicalOperator() {
            }
            Object.defineProperty(LogicalOperator, "MUST", {
                get: function () { return "MUST"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LogicalOperator, "SHOULD", {
                get: function () { return "SHOULD"; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(LogicalOperator, "MUST_NOT", {
                get: function () { return "MUST_NOT"; },
                enumerable: true,
                configurable: true
            });
            return LogicalOperator;
        }());
        pesquisaAvancada.LogicalOperator = LogicalOperator;
        var TraitListItem = /** @class */ (function () {
            function TraitListItem(id, value) {
                this.id = id;
                this.value = value;
            }
            ;
            return TraitListItem;
        }());
        pesquisaAvancada.TraitListItem = TraitListItem;
        var Criterion = /** @class */ (function () {
            function Criterion(logicalOperator, trait) {
                this.logicalOperator = logicalOperator;
                this.trait = trait;
                this.comparisonOperator = ComparisonOperator.EQUALS;
                this.valid = false;
                if (trait) {
                    if (trait.dataType === "constant") {
                        this.comparisonOperator = ComparisonOperator.EXISTS;
                        this.value = trait.name;
                    }
                    else if (trait.dataType === "date") {
                        this.comparisonOperator = ComparisonOperator.BETWEEN;
                    }
                    else if (trait.dataType === "string") {
                        this.comparisonOperator = ComparisonOperator.CONTAINS;
                    }
                }
                if (!logicalOperator) {
                    this.logicalOperator = LogicalOperator.MUST;
                }
            }
            return Criterion;
        }());
        pesquisaAvancada.Criterion = Criterion;
        var SearchBuilderDirective = /** @class */ (function () {
            function SearchBuilderDirective() {
                this.restrict = "E";
                this.templateUrl = "app/main/pesquisa-avancada/directives/search-builder/search-builder.html";
                this.scope = {
                    traits: "=",
                    search: "="
                };
                this.controller = pesquisaAvancada.SearchBuilderController;
                this.controllerAs = "vm";
            }
            SearchBuilderDirective.factory = function () {
                return function () { return new SearchBuilderDirective(); };
            };
            return SearchBuilderDirective;
        }());
        angular
            .module("app.pesquisa-avancada")
            .directive("searchBuilder", SearchBuilderDirective.factory());
    })(pesquisaAvancada = app.pesquisaAvancada || (app.pesquisaAvancada = {}));
})(app || (app = {}));
